import { render, staticRenderFns } from "./CaseDocuments.vue?vue&type=template&id=8134085a&scoped=true&lang=pug&"
import script from "./CaseDocuments.vue?vue&type=script&lang=js&"
export * from "./CaseDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CaseDocuments.vue?vue&type=style&index=0&id=8134085a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8134085a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VRow,VSnackbar})
